import { FUTURE_SPOT, FUTURE_SPOT_ERROR, FUTURE_SPOT_HIDE_ERROR, FUTURE_SPOT_START_LOADER, FUTURE_SPOT_STOP_LOADER, } from "../interface/iFutureSpot";
const initialState = {
    futuresSpots: {},
    futureSpotLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const futureSpotReducer = (state = initialState, action) => {
    switch (action.type) {
        case FUTURE_SPOT:
            return Object.assign(Object.assign({}, state), { futuresSpots: action.payload.data });
        case FUTURE_SPOT_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case FUTURE_SPOT_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case FUTURE_SPOT_START_LOADER:
            return Object.assign(Object.assign({}, state), { futureSpotLoader: true });
        case FUTURE_SPOT_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { futureSpotLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default futureSpotReducer;
